module.exports = __webpack_public_path__ + "img/taoshi.6e635826.svg";